import React, { useState, useEffect, useRef } from 'react';
import './Game1.css';

let TRASH_ITEMS = [
  { type: '塑膠袋', score: 5, image: `${process.env.PUBLIC_URL}/assets/plastic_bag.png` },
  { type: '塑膠袋', score: 5, image: `${process.env.PUBLIC_URL}/assets/plastic_bag.png` },
  { type: '寶特瓶', score: 5, image: `${process.env.PUBLIC_URL}/assets/bottle.png` },
  { type: '寶特瓶', score: 5, image: `${process.env.PUBLIC_URL}/assets/bottle.png` },
  { type: '塑膠吸管', score: 5, image: `${process.env.PUBLIC_URL}/assets/straw.png` },
  { type: '塑膠吸管', score: 5, image: `${process.env.PUBLIC_URL}/assets/straw.png` },
  { type: '衛生紙', score: 4, image: `${process.env.PUBLIC_URL}/assets/tissue.png` },
  { type: '衛生紙', score: 4, image: `${process.env.PUBLIC_URL}/assets/tissue.png` },
  { type: '鐵鋁罐', score: 4, image: `${process.env.PUBLIC_URL}/assets/can.png` },
  { type: '鐵鋁罐', score: 4, image: `${process.env.PUBLIC_URL}/assets/can.png` },
  { type: '便當盒', score: 3, image: `${process.env.PUBLIC_URL}/assets/lunch_box.png` },
  { type: '便當盒', score: 3, image: `${process.env.PUBLIC_URL}/assets/lunch_box.png` },
  { type: '餅乾盒', score: 3, image: `${process.env.PUBLIC_URL}/assets/cookie_box.png` },
  { type: '餅乾盒', score: 3, image: `${process.env.PUBLIC_URL}/assets/cookie_box.png` },
  { type: '牛奶盒', score: 3, image: `${process.env.PUBLIC_URL}/assets/milk_box.png` },
  { type: '牛奶盒', score: 3, image: `${process.env.PUBLIC_URL}/assets/milk_box.png` },

];

const getRandomPosition = () => {
  const x = Math.floor(Math.random() * 90); // 随机生成0-90之间的数
  const y = Math.floor(Math.random() * 40) + 50; // 随机生成50-90之间的数
  return { x, y };
};

const Game1 = () => {
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(15);
  const [lastClickTime, setLastClickTime] = useState(null);
  const [positions, setPositions] = useState([]);
  const [gameStarted, setGameStarted] = useState(false);
  const [hiddenItems, setHiddenItems] = useState(new Set());
  const [showStars, setShowStars] = useState(false);
  const audioRef = useRef(null);
  const clickSoundRef = useRef(null);

  useEffect(() => {
    if (gameStarted && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (timeLeft === 0) {
      setShowStars(true);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      setGameStarted(false);
    }
  }, [timeLeft, gameStarted]);

  useEffect(() => {
   
    const initialPositions = TRASH_ITEMS.map(() => getRandomPosition());
    setPositions(initialPositions);
  }, []);
  

  const handleStartGame = () => {
    setScore(0);
    setHiddenItems(new Set());
    setShowStars(false);
    setTimeLeft(15);
    setGameStarted(true);
 
    TRASH_ITEMS = TRASH_ITEMS.slice(0, 15);
    if (audioRef.current) {
      audioRef.current.play().catch(error => {
        console.error('Error playing audio:', error);
      });
    }
  };

  const handleTrashClick = (item, index) => {
    if (hiddenItems.has(index)) return; // 如果图片已经被点击过，则不再计分

    const currentTime = new Date().getTime();
    let additionalScore = item.score;

    if (lastClickTime && (currentTime - lastClickTime) <= 3000) {
      additionalScore *= 2;
    }

    setScore(prevScore => prevScore + additionalScore);
    setLastClickTime(currentTime);

    // 播放点击音效
    if (clickSoundRef.current) {
      clickSoundRef.current.play().catch(error => {
        console.error('Error playing click sound:', error);
      });
    }

    // 将点击过的图��标记为隐藏
    setHiddenItems(prevHiddenItems => new Set(prevHiddenItems).add(index));

    // 随机添加一张新的图片
    const newItem = TRASH_ITEMS[Math.floor(Math.random() * TRASH_ITEMS.length)];
    setPositions(prevPositions => [...prevPositions, getRandomPosition()]);
    TRASH_ITEMS.push(newItem);
  };

  const getStarRating = () => {
    if (score >= 300) return 3;
    if (score >= 200) return 2;
    if (score >= 100) return 1;
    return 0;
  };

  useEffect(() => {
    console.log(process.env.PUBLIC_URL)
    const font = new FontFace('WP010-05', `url(${process.env.PUBLIC_URL}/fonts/wp010-05.ttf)`);
    font.load().then((loadedFont) => {
      document.fonts.add(loadedFont);
      document.body.style.fontFamily = '"WP010-05", sans-serif';
    }).catch((error) => {
      console.error('Error loading font:', error);
    });
  }, []);

  return (
    <div className="container">
      <img
        src={`${process.env.PUBLIC_URL}/assets/background.png`}
        alt="background"
        className="background-image"
      />
      <audio ref={audioRef} loop>
        <source src={`${process.env.PUBLIC_URL}/assets/background.mp3`} type="audio/mpeg" />
        您的浏览器不支持 audio 元素。
      </audio>
      <audio ref={clickSoundRef}>
        <source src={`${process.env.PUBLIC_URL}/assets/click.mp3`} type="audio/mpeg" />
        您的浏览器不支持 audio 元素。
      </audio>
      {!gameStarted && (
        <>
          {score > 100 && (
            <div className="start-button1">
              恭喜過關
            </div>
          )}
          <div className="start-button" onClick={handleStartGame}>
            開始遊戲
          </div>
        </>
      )}
      <div className="timer">剩餘時間: {timeLeft} 秒</div>
      <div className="score">分數: {score}</div>
      <div className={`stars ${showStars ? 'visible' : ''}`}>星等: {getStarRating()} 顆星</div>
      {gameStarted && (
        <div className="trash-container">
          {TRASH_ITEMS.map((item, index) => {
            const { x, y } = positions[index] || { x: 0, y: 0 };
            return (
              <img
                key={index}
                src={item.image}
                alt={item.type}
                className={`trash-image ${hiddenItems.has(index) ? 'hidden' : ''}`}
                onClick={() => handleTrashClick(item, index)}
                onError={() => console.error(`Error loading image: ${item.image}`)}
                style={{ top: `${y}%`, left: `${x}%` }} // 随机位置
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Game1;